import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6 19h3.692v-5.077c0-.229.078-.42.232-.575a.782.782 0 0 1 .576-.232h3c.229 0 .42.077.575.232a.781.781 0 0 1 .233.575V19H18v-8.692a.579.579 0 0 0-.067-.28.745.745 0 0 0-.183-.22L12.366 5.75A.537.537 0 0 0 12 5.615a.537.537 0 0 0-.366.135L6.25 9.808a.746.746 0 0 0-.183.22.58.58 0 0 0-.067.28V19Zm-1 0v-8.692a1.603 1.603 0 0 1 .646-1.293l5.385-4.077c.282-.215.604-.323.966-.323s.686.108.972.323l5.385 4.077c.202.148.36.337.474.566.115.229.172.47.172.727V19a.96.96 0 0 1-.299.701A.96.96 0 0 1 18 20h-3.884a.78.78 0 0 1-.576-.232.782.782 0 0 1-.232-.576v-5.076h-2.616v5.076c0 .23-.077.42-.232.576a.78.78 0 0 1-.576.232H6a.96.96 0 0 1-.701-.299A.96.96 0 0 1 5 19Z" }, null, -1)
  ]))]))
}
export default { render: render }